import * as React from 'react'
import { apiCallWrapperNoDispatch, Popup, PopupFormWrapper, Select, SelectOptionModel } from 'traveldesk-ui'
import CitySelector from '../CitySelector/CitySelector'
interface Props {
    externalCityId: string
    externalCityName: string
    countriesOptions?: SelectOptionModel[]
    onCancel: () => void
    onCitySelected: (cityId: number) => void
}

const CitySelectorForm: React.FC<Props> = (props: Props) => {
  
    return (
        <Popup 
            onClose={props.onCancel}            
        >
        <PopupFormWrapper>
            <h3>Map City: {props.externalCityName} ({props.externalCityId})</h3>

               <CitySelector
                    countriesOptions={props.countriesOptions}
                    onCitySelected={(cityId: number) => props.onCitySelected(cityId)}
               />
            </PopupFormWrapper>
        </Popup>
    )
}
export default CitySelectorForm